import {Account} from './types/Account';
import {KeyValueObservable} from './util/observers/KeyValueObservable';
import {NavigateFunction} from "react-router";

export interface IAppState {
  user: Account | null | undefined;
  loadingUserDetails: boolean;
}

export type { Account } from './types/Account';

export interface IAppContext {
  user: Account | null | undefined;
  loadingUserDetails: boolean;
  updateUser: (user: Account, history: NavigateFunction, redirectPath?: string, state?: any) => void;
  clearUser: () => void;
  logout: () => void;
  refreshVerification: () => Promise<Account | null>;
  observableMap: KeyValueObservable<any> | undefined;
}

// Extend the global Window interface to include jQuery and pendo
declare global {
  interface Window {
    $: any;
    pendo: {
      initialize: (config?: any) => void;
      identify: (config?: any) => void;
      clearSession: () => void;
    };
  }
}

export interface NavItem {
  path: string;
  label: string;
  submenus?: NavItem[];
  icon?: string;
  exact?: boolean;
}

export interface ReportDialogSetterProps<T> {
  item: T | null;
  dialog: string | null;
}

export interface ReportDialogActionCloseProps<T> {
  item?: T | null;
  action?: string; //if not defined, the report should just close the dialog
}

export function getDefaultReportDialog<T>(): ReportDialogSetterProps<T> {
  return {
    item: null,
    dialog: null
  };
}

export interface ReportDialogWrapperProps<T> {
  dialog: ReportDialogSetterProps<T>;
  onClose: (action?: ReportDialogActionCloseProps<T>) => void;
}

export interface ReportDialogProps<T> {
  item: T | null;
  open: boolean;
  onClose: (action?: ReportDialogActionCloseProps<T>) => void;
}
